import React from "react";
import PropTypes from "prop-types";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { FiUser, FiMapPin } from "react-icons/fi";

import { getJVPartners } from "../../../lookups";

import "./client-view.css";

const Field = ({ label, value }) => (
  <>
    <span className="text-gray-500 py-1.5 text-sm">{label}</span>
    <span className="text-gray-900 font-semibold py-1.5 text-sm">{value || "—"}</span>
  </>
);

Field.propTypes = {
  label: PropTypes.string,
  value: PropTypes.node,
};

const SectionCard = ({ icon: Icon, title, children }) => (
  <div className="bg-white border border-gray-200 rounded-xl shadow-sm overflow-hidden mb-4">
    <div className="border-b border-gray-200 px-4 py-3">
      <h3 className="text-base font-bold text-gray-900 m-0 flex items-center gap-2">
        {Icon && <Icon size={18} className="text-blue-500" />}
        {title}
      </h3>
    </div>
    <div className="px-4 py-3">
      <div className="grid grid-cols-2 gap-x-6 gap-y-2">
        {children}
      </div>
    </div>
  </div>
);

SectionCard.propTypes = {
  icon: PropTypes.elementType,
  title: PropTypes.string,
  children: PropTypes.node,
};

const ClientView = ({ isShown, close, client, next, back, type }) => {
  const jvPartner = getJVPartners().find(
    (j) => j.id?.toString() === client.joint_venture?.toString()
  )?.long_name;

  const email = client.email
    ? client.email
    : client.contacts?.find((c) => c.type === "Email")?.detail;

  const phone = client.phone
    ? client.phone
    : client.contacts?.find((c) => c.type === "Cell")?.detail;

  const address = client.address || client.addresses?.[0]?.raw;
  const suburb = client.suburb || client.addresses?.[0]?.suburb;
  const city = client.city || client.addresses?.[0]?.city;
  const postalCode = client.postal_code || client.addresses?.[0]?.code;
  const province = client.province || client.addresses?.[0]?.province;
  const country = client.country || client.addresses?.[0]?.country;

  return (
    <Modal
      className="client-view-modal"
      animation={false}
      show={isShown}
      onHide={close}
    >
      <Modal.Header>
        <div>
          <span className="text-xs text-gray-400 uppercase tracking-wide font-medium">Client Name</span>
          <h3 className="text-lg font-bold text-gray-900 m-0 mt-1">{`${client.firstname} ${client.surname}`}</h3>
        </div>
      </Modal.Header>
      <Modal.Body className="!bg-gray-50 !p-4">
        <SectionCard icon={FiUser} title="Personal Information">
          <Field label="First Name" value={client.firstname} />
          <Field label="Last Name" value={client.surname} />
          <Field label="Date of Birth" value={client.birth} />
          <Field label="Email" value={email} />
          <Field label="Contact Number" value={phone} />
          <Field label="Identity Number" value={client.identity_number} />
          <Field label="TAX Number" value={client.tax_number} />
          <Field label="JV Partner" value={jvPartner} />
        </SectionCard>

        <SectionCard icon={FiMapPin} title="Address Information">
          <Field label="Physical Address" value={address} />
          <Field label="Suburb" value={suburb} />
          <Field label="City" value={city} />
          <Field label="Postal Code" value={postalCode} />
          <Field label="Province" value={province} />
          <Field label="Country" value={country} />
        </SectionCard>
      </Modal.Body>

      {type === "confirm" ? (
        <Modal.Footer>
          <Button variant="secondary" onClick={back}>
            Back
          </Button>
          <Button variant="success" onClick={next}>
            Confirm New Client
          </Button>
        </Modal.Footer>
      ) : (
        <></>
      )}
    </Modal>
  );
};

ClientView.propTypes = {
  isShown: PropTypes.bool,
  close: PropTypes.func,
  client: PropTypes.object,
  next: PropTypes.func,
  back: PropTypes.func,
  type: PropTypes.string,
};

export default ClientView;
